import { render, staticRenderFns } from "./TelegramModal.vue?vue&type=template&id=45808bea"
import script from "./TelegramModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TelegramModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports